import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'changeExam');
}
export const getMessage = (state) => getState(state).get('message');
export const getRates = (state) => getState(state).get('rates');
export const getExams = (state) => getState(state).get('exams');
export const getWaiting = (state) => getState(state).get('waiting');
